import React, { useEffect, useRef, useState } from 'react';
import './About.css'; // Stylesheet for both sections
import logo from './partner.svg'

// Placeholder URL for the composite partner logos


const AboutAndEvaluation = () => { // Renamed component for clarity
  const logoImageRef = useRef(null);
  const [isLogoVisible, setIsLogoVisible] = useState(false);

  useEffect(() => {
    if (!logoImageRef.current) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsLogoVisible(entry.isIntersecting);
        });
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    observer.observe(logoImageRef.current);
    return () => observer.disconnect();
  }, []);

  return (
      <div className="outer-container-about">
        <div className="about-main-container">
          <div className="about-section">
            <div className="section-title-wrap">
              <h2 className="section-title">About PoseX</h2>
            </div>
            <div className="content-wrapper">
              {/* Left side text */}
              <div className="text-content">
                <p>
                  Posex is supported by a dynamic team of industry partners, including MicroCyto, NVIDIA, and ByteDance, 
                  alongside top academic institutions such as Stanford University, Princeton University, Imperial College London, Purdue University, Peking University, Nanjing University, and Central South University.
                    This collaboration combines the expertise and resources of leading companies and universities to drive the success of our project.
                </p>
              </div>
              {/* Right side logo area */}
              <div className="logo-area">
                <img
                  ref={logoImageRef}
                  src={logo}
                  alt="Partner logos"
                  className={`composite-logo-image ${isLogoVisible ? 'is-visible' : ''}`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

// Make sure to export the renamed component if needed elsewhere
// export default AboutAndEvaluation;
export default AboutAndEvaluation; // Or keep original name if preferred